<template>
  <div class="cp-section" v-if="!isCPLoading">
    <OrderList v-if="isCustomerPortalOrderList" :input="input" title="Orders & Subscriptions" :params="params" @submit="submit" />
    <OrderDetail v-else-if="isCustomerPortalOrderDetail" @submit="selectInput"
                 :input="input" :side-menus="sideMenus"/>
  </div>
  <ProcessingLoader v-else />
</template>

<script>
import {InputType} from '@/constants'
import {mapState} from 'vuex'

const OrderList = () => import('./../Order/OrderList')
const OrderDetail = () => import('./../Order/OrderDetail')
const ProcessingLoader = () => import('@/components/ProcessingLoader')

export default {
  name: 'CustomerPortalOrders',
  components: {OrderList, OrderDetail, ProcessingLoader},
  props: {
    input: Object,
    sideMenus: Array
  },
  data: function() {
    return {
      params: {
        is_active: true
      }
    }
  },
  computed: {
    ...mapState(['session', 'isCPLoading']),
    isCustomerPortalOrderList: function() {
      return this.session && this.session['step_type'] === InputType.CustomerPortalOrders
    },
    isCustomerPortalOrderDetail: function() {
      return this.session && this.session['step_type'] === InputType.CustomerPortalOrderDetail
    }
  },
  methods: {
    submit: function(input) {
      this.$emit('submit', input)
    },
    selectInput: function(data) {
      this.$emit('selectItem', data)
    }
  }
}
</script>

<style scoped>

</style>
